export const dateFormat = 'MM/DD/YYYY';
export const timeFormat = 'HH:mm';

export const dateInFutureMessage = 'The date cannot be in the future.';
export const timeInFutureMessage = 'The time cannot be in the future.';
